/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-len */
/* eslint-disable max-lines */
import { CountertopSkuData } from '../types';


export type CountertopSkusDataCallback = () => Record<string, CountertopSkuData>;

export interface CountertopSkuOptions {
  callback?: CountertopSkusDataCallback;
}

export class CountertopSkuAssetData {
  private static instance: CountertopSkuAssetData;
  private data: Record<string, CountertopSkuData> = {};
  private callback: CountertopSkusDataCallback | null = null;

  constructor (options?: CountertopSkuOptions) {
  	if (options?.callback) {
  		this.callback = options.callback;
  		this.loadData();
  	}
  }

  static getInstance (options?: CountertopSkuOptions): CountertopSkuAssetData {
  	if (!CountertopSkuAssetData.instance) {
  		CountertopSkuAssetData.instance = new CountertopSkuAssetData(options);
  	}
  	return CountertopSkuAssetData.instance;
  }

  /**
   * Set the callback function that provides the CountertopSkus data
   */
  static setCallback (callback: CountertopSkusDataCallback): void {
  	CountertopSkuAssetData.getInstance().callback = callback;
  	CountertopSkuAssetData.getInstance().loadData();
  }

  /**
   * Get all CountertopSkus data
   */
  static getData (): Record<string, CountertopSkuData> {
  	return CountertopSkuAssetData.getInstance().data;
  }

  /**
   * Get CountertopSku data by SKU
   */
  static findBySku (sku: string): CountertopSkuData | null {
  	return CountertopSkuAssetData.getInstance().data[sku] || null;
  }


  /**
   * Get all SKUs
   */
  static getAllSkus (): string[] {
  	return Object.keys(CountertopSkuAssetData.getInstance().data);
  }

  /**
   * Add or update an CountertopSku
   */
  static addCountertopSku (sku: string, componentData: CountertopSkuData): void {
  	CountertopSkuAssetData.getInstance().data[sku] = componentData;
  }

  /**
   * Remove an CountertopSku
   */
  static removeCountertopSku (sku: string): boolean {
  	const instance = CountertopSkuAssetData.getInstance();
  	if (instance.data[sku]) {
  		delete instance.data[sku];
  		return true;
  	}
  	return false;
  }

  /**
   * Load data using the registered callback
   */
  private loadData (): void {
  	if (this.callback) {
  		const rawData = this.callback();
  		// Ensure msrp is a number (API might return strings)
  		this.data = Object.fromEntries(
  			Object.entries(rawData).map(([sku, item]) => [
  				sku,
  				{ ...item, msrp: Number(item.msrp) || 0 }
  			])
  		);
  	}
  }

  /**
   * Reload data
   */
  static reload (): void {
  	CountertopSkuAssetData.getInstance().loadData();
  }

  /**
   * Clear all data
   */
  static clear (): void {
  	CountertopSkuAssetData.getInstance().data = {};
  }
}
